import { HierarchyContextProps, IHierarchyActionSetSaveRequestStatus } from "../interface";

/**
 * Updates hierarchy save status, rejecting settlement from a superseded request.
 * TODO: Remove this, implement via useSave
 *
 * @param state - The current hierarchy context state.
 * @param action - The set-hierarchy-save-request-status action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_setHierarchySaveRequestStatus = (
  state: HierarchyContextProps,
  action: IHierarchyActionSetSaveRequestStatus,
): HierarchyContextProps =>
  action.expectedCancel && state.saveRequestStatus.cancel !== action.expectedCancel
    ? state
    : {
        ...state,
        saveRequestStatus: action.saveRequestStatus,
      };
